import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { Theme, darkTheme, ThemeMode } from '../styles/theme';

interface ThemeContextType {
  theme: Theme;
  mode: ThemeMode;
  toggleTheme: () => void;
  setTheme: (mode: ThemeMode) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [mode] = useState<ThemeMode>('dark');

  const theme = darkTheme;

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark');
    localStorage.setItem('theme-mode', 'dark');
  }, []);

  const toggleTheme = () => {
    // No-op: Dark mode enforced
  };

  const setTheme = (_: ThemeMode) => {
    // No-op: Dark mode enforced
  };

  return (
    <ThemeContext.Provider value={{ theme, mode, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
